export default {
  svgPath: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5 15V9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V15H21V17H3V15H5ZM17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9V15H17V9Z" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9 19C9 20.6569 10.3431 22 12 22C13.6569 22 15 20.6569 15 19H9Z" /> `,
  title: 'Bell',
  viewBox: '0 0 21 20',
};
